// Super admin — a distinction above the normal 'admin' role.
//
// Everyone here already holds the 'admin' role. This is what gates the bulk
// "Send to Lenders" action: an admin who is not on this list sees only Confirm
// & Submit. A named whitelist that once granted three reps the action without
// the distinction has been revoked, so this list is now the only way to have it.
//
// Matched on email because that is the stable identifier already carried on the
// session user, so no account records have to change to grant or revoke this.
// Comparison is case-insensitive, so an address stored with capitals on the
// account still matches its lowercase entry here.
//
// NOTE: this governs what the interface offers, not what the API will accept.
// Anything that must actually be prevented has to be enforced on the server.
export const SUPER_ADMIN_EMAILS = [
  'alexs@capital-infusion.com',      // Alex Stetkevych
  'jasonk@capital-infusion.com',     // Jason Kim
  'chris@capital-infusion.com',      // Chris Cranton
  'jennifer@capital-infusion.com',   // Jennifer
  'marco@capital-infusion.com',      // Marco
  'alexa@capital-infusion.com',      // Alexa Bonilla
  'natalie@capital-infusion.com',    // Natalie Samara - confirmed real staff
                                      // account (role: admin), separate from
                                      // Nathalia Nava (nathalia@, a rep, not
                                      // this person - see the git history on
                                      // this file for the earlier mix-up).
  'dianne@capital-infusion.com',     // Dianne Acosta
  'anna@capital-infusion.com',       // Anna Deschamps
  'jessica@capital-infusion.com',    // Jessica
  // Santiago and Careem are ultra admins — they are NOT super admins.
  // Ultra admins use Send to Admins, not Send to Lenders.
];

// Ultra admins — the only users who see "Send to Admins" replaced by
// "Send to Lenders" directly. Everyone else (including regular super admins)
// must go through the admin queue first.
export const ULTRA_ADMIN_EMAILS = [
  'santiago@capital-infusion.com',  // Santiago
  'careem@capital-infusion.com',    // Careem Roberts
];

const matches = (user, list) => {
  const email = (user?.email || '').trim().toLowerCase();
  if (!email) return false;
  return list.some(e => e.toLowerCase() === email);
};

/** True when the signed-in user holds the super admin distinction. */
export function isSuperAdmin(user) {
  return matches(user, SUPER_ADMIN_EMAILS);
}

/** True when the signed-in user is an ultra admin (Santiago / Careem). */
export function isUltraAdmin(user) {
  return matches(user, ULTRA_ADMIN_EMAILS);
}
